import LineAnnotation from '../annotations/LineAnnotation';
import RectangleAnnotation from '../annotations/RectangleAnnotation';
import TextAnnotation from '../annotations/TextAnnotation';

const drawLine = (chart, params = {}) => {
	const annotation = new LineAnnotation(
		chart.panels[0],
		params
	);
	annotation.render();
};

const drawRectangle = (chart, params = {}) => {
	const annotation = new RectangleAnnotation(
		chart.panels[0],
		params
	);
	annotation.render();
};

const drawText = (chart, params = {}) => {
	const annotation = new TextAnnotation(
		chart.panels[0],
		params
	);
	annotation.render();
};

export default {
	drawLine,
	drawRectangle,
	drawText
};
